import { render, staticRenderFns } from "./LayoutsUseOfBarTwoSection.vue?vue&type=template&id=70465b8d"
import script from "./LayoutsUseOfBarTwoSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsUseOfBarTwoSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsUseOfBarTwoSection.vue?vue&type=style&index=0&id=70465b8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports